function PageNotFound() {
  return (
    <>
        <p>PageNotFound</p>
    </>
);
}

export default PageNotFound;
